import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "onboarding-summary" }
const _hoisted_2 = { class: "onboarding-summary__backgrounds-mount" }
const _hoisted_3 = { class: "onboarding-summary__stack" }

import { computed } from 'vue'

import { QuestionnaireView } from '@/models/onboarding'
import type { LearningSetupSummaryPage } from '@/models/onboarding.types'
import {
  buildLearningSetupSummaryRows,
  getLikedBookSlugsFromUserChoices,
} from '@/models/onboarding.personalization'

import Layout from '../Layout.vue'
import Logo from '@/components/ui/Logo.vue'
import LearningSetupSummaryBackgrounds from './LearningSetupSummaryBackgrounds.vue'
import LearningSetupSummaryBooksSection from './LearningSetupSummaryBooksSection.vue'
import LearningSetupSummaryChoicesSection from './LearningSetupSummaryChoicesSection.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'LearningSetupSummary',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const page = computed(() => {
  return props.view.currentPage as LearningSetupSummaryPage
})

const summaryRows = computed(() =>
  buildLearningSetupSummaryRows(props.view.userChoices),
)

const likedSlugs = computed(() =>
  getLikedBookSlugsFromUserChoices(props.view.userChoices),
)

function getBookCover(slug: string): string {
  return props.view.getBookCover(slug)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LearningSetupSummaryBackgrounds)
    ]),
    _createVNode(Logo, {
      class: "onboarding-summary__logo",
      withText: true
    }),
    _createVNode(Layout, {
      title: page.value.title,
      subtitle: page.value.subtitle,
      reverseTitleSubtitle: true,
      scrollDefaultSlot: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (summaryRows.value.length)
            ? (_openBlock(), _createBlock(LearningSetupSummaryChoicesSection, {
                key: 0,
                rows: summaryRows.value
              }, null, 8, ["rows"]))
            : _createCommentVNode("", true),
          (likedSlugs.value.length)
            ? (_openBlock(), _createBlock(LearningSetupSummaryBooksSection, {
                key: 1,
                slugs: likedSlugs.value,
                "cover-url": getBookCover
              }, null, 8, ["slugs"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["title", "subtitle"])
  ]))
}
}

})